<template>
  <div class="diceBg" :class="{'part': $route.meta.text == '파트너 페이지', 'dashboard-root': $route.name === 'main'}">
    <div class="diceBgDark dice" :class="{'dashboard-shell': useEditorialShell, 'subpage-shell': useEditorialShell && $route.name !== 'main'}">
      <main-header v-if="useEditorialShell" :selectedMenu="selectedMenu" />
      <div class="content0" :class="{'sub': $route.name !== 'main'}">
        <router-view :key="$route.fullPath"></router-view>
        <main-footer v-if="banner && $route.name !== 'main'" />
      </div>
    </div>
  </div>

  <slot-list v-if="isSlotOpen" :groupCode="groupCode" :codeName="codeName" :code="code" @isSlot="isSlotOpen = false"></slot-list>
  <loading></loading>
</template>

<script>
import MainHeader from './Header'
import MainFooter from './Footer'
import SlotList from '@/components/game/SlotList'
import { mapState } from 'vuex'
import Loading from '@/components/common/Loading.vue'

export default {
  name: 'DefaultLayout',
  components: {
    Loading,
    SlotList,
    MainHeader,
    MainFooter
  },
  computed: {
    ...mapState([
      'banner'
    ]),
    useEditorialShell () {
      return ![
        'partnerCashList',
        'partnerBettingList',
        'partnerList',
        'partnerCalculationList',
        'partnerCalculationUserList',
        'partnerMemberList',
        'partnerMoneyMoveList'
      ].includes(this.$route.name)
    }
  },
  mounted () {
    this.syncDashboardBodyClass()
    this.emitter.emit('Loading', false)
    this.emitter.on('isSlot', (data) => {
      if (data) {
        const groupCode = data.groupCode
        const codeName = data.codeName
        const code = data.code
        this.getSlotOpen(groupCode, codeName, code)
      } else {
        this.isSlotOpen = false
      }
    })
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeMount () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  beforeUnmount () {
    document.body.classList.remove('mega13-nova-body')
  },
  watch: {
    '$route.name' () {
      this.syncDashboardBodyClass()
      this.emitter.emit('Loading', false)
      this.$vfm.hideAll()
    }
  },
  data () {
    return {
      isSlotOpen: false,
      groupCode: '',
      codeName: '',
      code: '',
      isLoading: false,
      selectedMenu: ''
    }
  },
  methods: {
    syncDashboardBodyClass () {
      document.body.classList.toggle('mega13-nova-body', this.useEditorialShell)
    },
    scrollToSection (menu) {
      const sectionId = menu.replace(/ /g, '')
      const sectionElement = document.getElementById(sectionId)
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: 'smooth' })
      }
    },
    handleScroll () {
      const sectionElements = document.querySelectorAll('section')
      const selectedSection = Array.from(sectionElements).find((section) => {
        const rect = section.getBoundingClientRect()
        return rect.top <= 0 && rect.bottom > 0
      })
      if (selectedSection) {
        this.selectedMenu = selectedSection.id
      }
    },
    getSlotOpen (groupCode, codeName, code) {
      if (this.userData) {
        this.groupCode = groupCode
        this.codeName = codeName
        this.code = code
        this.isSlotOpen = true
      } else {
        this.onCheck('front.error.afterSignin')
      }
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'GmarketSans';
  src: url('../assets/fonts/gmarket-main/GmarketSansLight.woff2') format('woff2');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'GmarketSans';
  src: url('../assets/fonts/gmarket-main/GmarketSansMedium.woff2') format('woff2');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'GmarketSans';
  src: url('../assets/fonts/gmarket-main/GmarketSansBold.woff2') format('woff2');
  font-weight: 700 900;
  font-style: normal;
  font-display: swap;
}
/* .diceBg {background: url(../assets/img/main_bgobj.png) repeat; background-size: 10%;} */
.diceBgDark {width: 100%; height: 100%;}
.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.5s ease-in;
}

.fade-leave-active {
  transition: opacity 0.2s ease-in;
}

.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter {
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}

.slide-up-enter {
  transform: translateY(185px);
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-leave-to {
  transform: translateY(0px);
  opacity: 0;
}
.part {background: #fff;}
.sub {background: url(../assets/img/sub-bg.jpg) center no-repeat;background-size: cover;}

/* MEGA main-only compact navigation */
.dashboard-shell,
.dashboard-shell button,
.dashboard-shell input,
.dashboard-shell select,
.dashboard-shell textarea {
  font-family: 'GmarketSans', sans-serif;
}
.dashboard-shell .leftHeader {
  width: 148px;
  min-width: 148px;
  padding: 0 10px;
  background: linear-gradient(180deg, #11131a 0%, #090a0e 100%);
  border-right: 1px solid #292b33;
  box-shadow: 14px 0 35px rgba(0, 0, 0, .28);
  overflow: visible;
}
.dashboard-shell .content0 {
  width: calc(100% - 148px);
}
.dashboard-shell header.side {
  padding-left: 168px;
}
@media (max-width:1000px) {
  .dashboard-shell {display:block;background:#0c0c0e!important}
  .dashboard-shell .content0 {width:100%;max-width:100%;margin:0;background:#0c0c0e}
  .dashboard-shell .leftHeader {display:none}
  .dashboard-shell header.side {padding-left:0}
}
.dashboard-shell .leftHeader .logowrap {
  height: 82px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dashboard-shell .leftHeader .logowrap a {
  width: 54px;
  height: 54px;
  border: 1px solid #b79045;
  border-radius: 16px;
  background: linear-gradient(145deg, #2f2719, #15161c);
  display: flex;
  align-items: center;
  justify-content: center;
}
.dashboard-shell .leftHeader .logowrap a::after {
  content: 'M';
  color: #e2bd68;
  font-family: Georgia, serif;
  font-size: 28px;
  font-weight: 800;
}
.dashboard-shell .leftHeader .logowrap img {
  display: none;
}
.dashboard-shell .leftNav {
  padding: 12px 0 0;
  gap: 9px;
}
.dashboard-shell .leftNav > ul {
  position: relative;
}
.dashboard-shell .leftNav > ul.utility-nav {display:flex}
.dashboard-shell .leftNav > ul.utility-nav.money-nav {
  order:10;
  margin-top:14px!important;
  padding-top:14px;
  border-top:1px solid #29292d;
}
.dashboard-shell .leftNav > ul.utility-nav.account-nav {order:11}
.dashboard-shell .leftNav > ul.utility-nav.support-nav {order:12}
.dashboard-shell .leftNav > ul.utility-nav .utility-duplicate {display:none}
.dashboard-shell .leftNav > ul.utility-nav > li {
  width:128px;
  min-height:46px;
}
.dashboard-shell .leftNav > ul.utility-nav > li > a {
  position:relative;
  width:124px;
  height:46px;
  border-radius:10px;
}
.dashboard-shell .leftNav > ul.utility-nav > li > a em {
  width:30px;
  height:42px;
  flex:0 0 30px;
  background-size:19px;
  opacity:.62;
}
.dashboard-shell .leftNav > ul.utility-nav > li:hover > a,
.dashboard-shell .leftNav > ul.utility-nav > li.on > a {
  border:1px solid rgba(189,163,111,.4);
  background:rgba(138,112,66,.13);
  box-shadow:none;
}
.dashboard-shell .leftNav > ul.utility-nav > li:hover > a em,
.dashboard-shell .leftNav > ul.utility-nav > li.on > a em {opacity:1}
.dashboard-shell .leftNav > ul.utility-nav > li > a::after {
  display:none;
}
.dashboard-shell .leftNav > ul > li {
  width: 128px;
  min-height: 58px;
}
.dashboard-shell .leftNav > ul > li::after {
  display: none;
}
.dashboard-shell .leftNav > ul > li > a {
  width: 124px;
  height: 58px;
  margin: 0 auto;
  padding: 0 10px;
  border: 1px solid transparent;
  border-radius: 10px;
  color: #aaa6a0;
  font-size: 11px;
  justify-content: flex-start;
  gap: 8px;
}
.dashboard-shell .leftNav > ul > li:hover > a,
.dashboard-shell .leftNav > ul > li > a.on {
  border-color: rgba(214, 174, 89, .55);
  background: linear-gradient(145deg, #2b251a, #17181e);
  box-shadow: 0 9px 22px rgba(0, 0, 0, .25);
}
.dashboard-shell .leftNav > ul > li > a em {
  width: 30px;
  height: 42px;
  flex: 0 0 30px;
}
.dashboard-shell .leftNav .dropdown-toggle i {
  display: none;
}
.dashboard-shell .leftNav .dropdown-menu {
  position: absolute;
  left: 136px;
  top: 0;
  z-index: 30;
  width: 230px;
  max-height: 420px;
  padding: 10px;
  overflow-y: auto;
  border: 1px solid #343640;
  border-radius: 14px;
  background: rgba(17, 19, 26, .98);
  box-shadow: 18px 20px 45px rgba(0, 0, 0, .48);
  backdrop-filter: blur(15px);
}
.dashboard-shell .leftNav .dropdown-menu > ul,
.dashboard-shell .leftNav .dropdown-menu li {
  display: block;
}
.dashboard-shell .leftNav .dropdown-menu a {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border-radius: 9px;
  box-sizing: border-box;
  color: #b9bbc4;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.dashboard-shell .leftNav .dropdown-menu a:hover {
  color: #edcd82;
  background: #25221d;
}
.dashboard-shell .leftNav .dropname {
  overflow: hidden;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* MEGA muted editorial theme */
.dashboard-shell {
  --mega-bg: #0c0d0f;
  --mega-surface: #141516;
  --mega-surface-raised: #1b1c1d;
  --mega-border: #303032;
  --mega-primary: #8a7042;
  --mega-primary-bright: #bda36f;
  --mega-secondary: #7d796e;
  --mega-text: #e9e6e1;
  --mega-muted: #8d8a84;
  min-height: 100vh;
  background: #0c0c0e !important;
}
.dashboard-root {min-height:100vh;background:#0c0c0e !important}
body.mega09-editorial-body {
  min-width:320px;
  background:#0b0b0c;
}
.dashboard-root,
.dashboard-shell,
.dashboard-shell .content0 {
  min-width:0;
  max-width:100%;
  box-sizing:border-box;
}
.dashboard-root,
.dashboard-shell {width:100%}
.dashboard-shell .content0 {flex:1 1 auto}
.dashboard-shell .leftHeader {
  background:
    radial-gradient(circle at 50% 9%, rgba(154, 123, 69, .12), transparent 24%),
    linear-gradient(180deg, #161617 0%, #0c0d0e 100%);
  border-right-color: #2a2929;
}
.dashboard-shell .leftHeader .logowrap a {
  border-color: rgba(189, 163, 111, .46);
  background: linear-gradient(145deg, #2b271f, #171718);
  box-shadow: inset 0 0 18px rgba(138, 112, 66, .1), 0 10px 28px rgba(0, 0, 0, .3);
}
.dashboard-shell .leftHeader .logowrap a::after {
  color: var(--mega-primary-bright);
  text-shadow: 0 2px 12px rgba(0, 0, 0, .48);
}
.dashboard-shell .leftNav > ul > li > a em {
  opacity: .66;
  filter: grayscale(1) brightness(1.7);
  transition: opacity .2s, filter .2s;
}
.dashboard-shell .leftNav > ul > li:hover > a,
.dashboard-shell .leftNav > ul > li > a.on {
  border-color: rgba(189, 163, 111, .42);
  background: linear-gradient(145deg, rgba(138, 112, 66, .19), #1a1a1b 72%);
  box-shadow: inset 0 0 16px rgba(138, 112, 66, .06), 0 10px 24px rgba(0, 0, 0, .28);
}
.dashboard-shell .leftNav > ul > li:hover > a em,
.dashboard-shell .leftNav > ul > li > a.on em {
  opacity: 1;
  filter: grayscale(1) brightness(2.2);
}
.dashboard-shell .leftNav .dropdown-menu {
  border-color: #383637;
  background: rgba(20, 20, 21, .98);
  box-shadow: 20px 24px 48px rgba(0, 0, 0, .48), 0 0 0 1px rgba(138, 112, 66, .05);
}
.dashboard-shell .leftNav .dropdown-menu a:hover {
  color: #d4c29b;
  background: linear-gradient(90deg, rgba(138, 112, 66, .22), rgba(125, 121, 110, .07));
}
.dashboard-shell .leftNav > ul > li > a,
.dashboard-shell .leftNav > ul.utility-nav > li > a {
  position: relative;
  overflow: hidden;
  border-color: transparent;
  border-radius: 6px;
  background: transparent;
  box-shadow: none;
}
.dashboard-shell .leftNav > ul > li > a::before,
.dashboard-shell .leftNav > ul.utility-nav > li > a::before {
  content: '';
  position: absolute;
  left: 0;
  top: 11px;
  bottom: 11px;
  width: 2px;
  background: #b6a06a;
  opacity: 0;
  transition: opacity .18s;
}
.dashboard-shell .leftNav > ul > li:hover > a,
.dashboard-shell .leftNav > ul > li.on > a,
.dashboard-shell .leftNav > ul > li > a.on,
.dashboard-shell .leftNav > ul.utility-nav > li:hover > a,
.dashboard-shell .leftNav > ul.utility-nav > li.on > a {
  border-color: transparent;
  background: #171718;
  box-shadow: none;
}
.dashboard-shell .leftNav > ul > li:hover > a::before,
.dashboard-shell .leftNav > ul > li.on > a::before,
.dashboard-shell .leftNav > ul > li > a.on::before,
.dashboard-shell .leftNav > ul.utility-nav > li:hover > a::before,
.dashboard-shell .leftNav > ul.utility-nav > li.on > a::before {
  opacity: 1;
}
.dashboard-shell .head_info {
  background: #101112;
  border-bottom: 1px solid #282728;
}
.dashboard-shell .topbannerin span {
  color: #c7c8cf;
}
.dashboard-shell .coninpoint {
  border-color: rgba(189, 163, 111, .42);
  background: rgba(43, 37, 27, .88);
  box-shadow: inset 0 0 16px rgba(138, 112, 66, .06), 0 8px 22px rgba(0, 0, 0, .24);
}
.dashboard-shell .coninpoint li span {
  color: #c8b17f;
}
.dashboard-shell .headerbtn {
  border-color: rgba(189, 163, 111, .48);
  background: linear-gradient(135deg, #5b492b, #8a7042);
  color: #f1ece9;
}

/* MEGA shared subpage layout */
.subpage-shell .content0.sub {
  min-height: 100vh;
  padding: 88px 24px 72px;
  background: #0c0c0e;
  color: #eeeae6;
  box-sizing: border-box;
}
.subpage-shell .w1260,
.subpage-shell .w900 {width:min(1260px,100%);margin-right:auto;margin-left:auto}
.subpage-shell .snavi {display:none}
.subpage-shell .subBanner {
  min-height:44px;
  margin:0 0 16px;
  gap:10px;
  color:#eeeae6;
  font-size:24px;
  font-weight:700;
  letter-spacing:-.03em;
}
.subpage-shell .subBanner img {width:22px;height:22px;opacity:.75}
.subpage-shell .navSide {margin:0 0 20px}
.subpage-shell .boardnav {
  height:48px;
  gap:26px;
  border-bottom:1px solid #29292d;
  align-items:stretch;
}
.subpage-shell .boardnav>li {width:auto}
.subpage-shell .boardnav>li>span {
  position:relative;
  min-width:120px;
  height:48px;
  padding:0 2px;
  border:0;
  background:transparent;
  color:#8f8b87;
  font-size:12px;
}
.subpage-shell .boardnav>li.on>span,
.subpage-shell .boardnav>li:hover>span {border:0;background:transparent;color:#eeeae6}
.subpage-shell .boardnav>li.on>span::after {
  content:'';
  position:absolute;
  right:0;
  bottom:-1px;
  left:0;
  height:2px;
  background:#a98d57;
}
.subpage-shell .boardwrap {
  gap:16px;
  margin-bottom:48px;
  padding:0;
  border:0;
  border-radius:0;
  background:transparent;
  box-shadow:none;
}
.subpage-shell .moneyread,
.subpage-shell .mybetwrap,
.subpage-shell .board {
  border:1px solid #302f30;
  border-radius:8px;
  background:#141416;
  box-shadow:none;
}
.subpage-shell .moneyread {padding:22px 24px}
.subpage-shell .moneyread h3 {color:#d5c39c;font-size:14px;font-weight:600}
.subpage-shell .moneyread ul li {color:#aaa6a1;font-size:11px;line-height:1.8}
.subpage-shell .mybetwrap {padding:24px}
.subpage-shell .moneyinfo {padding:0 0 18px;border:0;border-bottom:1px solid #29292d}
.subpage-shell .applih {color:#d0b87f;font-size:13px}
.subpage-shell .applip {color:#817e79;font-size:11px}
.subpage-shell .appliinputwrap {display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px 20px;padding-top:4px}
.subpage-shell .appliinputwrap>ul {margin-top:14px}
.subpage-shell .appliinput {width:100%;gap:8px;color:#c9c5c0;font-size:11px}
.subpage-shell .appliinput li {width:100%}
.subpage-shell .appliinput li:nth-child(2) {
  height:42px;
  border:1px solid #302f30;
  border-radius:6px;
  background:#101012;
  box-shadow:none;
}
.subpage-shell .moneybtnwrap {grid-column:1/-1;flex-wrap:wrap}
.subpage-shell .moneybtnwrap a {border:1px solid #343334;border-radius:6px;background:#1b1b1d;color:#bbb6b0}
.subpage-shell .moneybtnwrap li:hover a {border-color:#8a7042;color:#e2d4b5}
.subpage-shell .applibtns a,
.subpage-shell .blsbtn {border:1px solid #8a7042;border-radius:7px;background:#8a7042;color:#f5f1e9;box-shadow:none}
.subpage-shell .board {overflow:hidden}
.subpage-shell .board>.boardw.first:first-child,
.subpage-shell .boardw,
.subpage-shell .wblbg.boardw,
.subpage-shell .wywbg.boardw {
  border:0;
  border-bottom:1px solid #29292d;
  background:#141416;
  color:#c9c5c0;
}
.subpage-shell .board>.boardw.first:first-child {background:#101012;color:#8f8b87}
.subpage-shell .boardw:hover {background:#1b1b1e}
.subpage-shell .boardw:last-child {border-bottom:0}
.subpage-shell .boardw li {font-size:11px}
.subpage-shell .boardw .bkc,
.subpage-shell .boardw .ywc {color:#d8d2ca}
.subpage-shell .moneyinfoappli {
  padding:24px;
  border:1px solid #302f30;
  border-radius:8px;
  background:#141416;
}
.subpage-shell .moneyinfoappli .moneyinfo {margin-bottom:4px}
.subpage-shell .applibtn {
  width:auto;
  height:34px;
  margin-top:12px;
  padding:0 14px;
  border:1px solid #5f5137;
  border-radius:6px;
  background:#211e18;
  color:#cdbb92;
  text-shadow:none;
}
.subpage-shell .applistep {color:#8f8b87}
.subpage-shell .applistep li {color:#8f8b87;font-size:11px}
.subpage-shell .applistep strong {color:#d0bc91}
.subpage-shell .applibtns {margin:18px 0 28px;text-align:right}
.subpage-shell .applibtns a {display:inline-flex;min-width:120px;height:40px;padding:0 22px;align-items:center;justify-content:center;box-sizing:border-box}
.subpage-shell .moneyreadWrap {margin-top:20px;padding:0}
.subpage-shell .rollName {
  margin:16px 0 10px;
  padding:14px 16px;
  border:1px solid #302f30;
  border-radius:7px;
  background:#141416;
  color:#98938d;
  font-size:11px;
  line-height:1.6;
}
.subpage-shell .rollName span {color:#d0bc91}
.subpage-shell .pointlist {
  display:grid;
  grid-template-columns:repeat(4,minmax(0,1fr));
  gap:8px;
  margin:0 0 16px;
}
.subpage-shell .pointlist>li {
  padding:14px;
  border:1px solid #302f30;
  border-radius:7px;
  background:#141416;
  color:#aaa6a1;
}
.subpage-shell .pointlist .rolling {color:#d0bc91}
.subpage-shell .datesearch {
  display:flex;
  align-items:flex-end;
  gap:12px;
  margin-bottom:16px;
  padding:14px;
  border:1px solid #302f30;
  border-radius:7px;
  background:#141416;
}
.subpage-shell .datesearch>select,
.subpage-shell .searchselect,
.subpage-shell .searchinput,
.subpage-shell .boardwrt input,
.subpage-shell .boardwrt select,
.subpage-shell .boardwrt textarea,
.subpage-shell .joinu input {
  border:1px solid #302f30;
  border-radius:6px;
  background:#101012;
  color:#eeeae6;
  box-shadow:none;
}
.subpage-shell .datesearch>select {min-width:170px;height:40px;padding:0 10px}
.subpage-shell .datewrap {border-color:#302f30;background:#101012;box-shadow:none}
.subpage-shell .datewrap input,
.subpage-shell .datewrap select {border-color:#302f30;background:#141416;color:#ddd8d2}
.subpage-shell .searchwrap {margin:0 0 16px}
.subpage-shell .searchselect,
.subpage-shell .searchinput {height:38px}
.subpage-shell .searchicon {height:38px;border:1px solid #8a7042;border-radius:6px;background:#8a7042;color:#f5f1e9;text-shadow:none}
.subpage-shell .box {
  padding:20px;
  border:1px solid #302f30;
  border-radius:8px;
  background:#141416;
}
.subpage-shell .box .board {border-radius:7px}
.subpage-shell .boardbtn {margin-top:16px}
.subpage-shell .boardbtn a,
.subpage-shell .boardbtn button,
.subpage-shell .grbbtn,
.subpage-shell .grsbtn,
.subpage-shell .rdsbtn02 {
  min-height:34px;
  padding:0 14px;
  border:1px solid #4a4743;
  border-radius:6px;
  background:#1b1b1d;
  color:#c8c2bb;
  box-shadow:none;
  text-shadow:none;
}
.subpage-shell .boardbtn a:hover,
.subpage-shell .boardbtn button:hover,
.subpage-shell .grbbtn:hover {border-color:#8a7042;color:#e1d1ad}
.subpage-shell .mybetwrap .tab-content {color:#c9c5c0}
.subpage-shell .joinu {gap:8px}
.subpage-shell .joinu li:first-child {color:#aaa6a1;font-size:11px}
.subpage-shell .joinu li+li,
.subpage-shell .joinu li.myfix_id {
  width:100%;
  height:42px;
  padding:0 13px;
  border:1px solid #302f30;
  border-radius:6px;
  background:#101012;
  color:#eeeae6;
  box-sizing:border-box;
}
.subpage-shell .joinu input {height:40px;padding:0;width:100%}
.subpage-shell .joinubottom {
  margin:16px 0 24px;
  padding:14px 18px;
  border:1px solid #302f30;
  border-radius:7px;
  background:#141416;
}
.subpage-shell .joinubottom .joinub {width:100%;padding:7px 0;border-bottom:1px solid #29292d}
.subpage-shell .joinubottom .joinub:last-child {border-bottom:0}
.subpage-shell .detailPop,
.subpage-shell .betlist-content {
  border:1px solid #3a3838;
  border-radius:8px;
  background:#141416;
  color:#eeeae6;
  box-shadow:0 24px 60px rgba(0,0,0,.5);
}
.subpage-shell .detailPop h4,
.subpage-shell .betlist-title {border-bottom:1px solid #302f30;background:#181819;color:#d8c69f}
@media (max-width:900px) {
  .subpage-shell .content0.sub {padding-right:14px;padding-left:14px}
  .subpage-shell .appliinputwrap {grid-template-columns:1fr}
  .subpage-shell .pointlist {grid-template-columns:repeat(2,minmax(0,1fr))}
}

/* Legacy shell compatibility layer */
body.mega13-nova-body {overflow-x:hidden;background:#080811}
.dashboard-root,.dashboard-shell,.dashboard-shell .content0 {background:#080811!important}
.dashboard-shell {
  --mega-primary:#7c3aed;
  --mega-primary-bright:#b7a2ff;
  --mega-secondary:#5eead4;
  --mega-text:#f5f3ff;
  --mega-muted:#88859c;
}
.dashboard-shell .leftHeader {
  border-right-color:rgba(255,255,255,.08);
  background:radial-gradient(circle at 50% 8%,rgba(124,58,237,.22),transparent 22%),linear-gradient(180deg,#111020,#090914 70%)
}
.dashboard-shell .leftHeader .logowrap a {
  border-color:rgba(167,139,250,.48);
  background:linear-gradient(145deg,rgba(124,58,237,.28),rgba(20,184,166,.1));
}
.dashboard-shell .leftHeader .logowrap a::after {color:#c4b5fd;text-shadow:0 0 20px rgba(139,92,246,.5)}
.dashboard-shell .leftNav>ul>li:hover>a,
.dashboard-shell .leftNav>ul>li.on>a,
.dashboard-shell .leftNav>ul>li>a.on,
.dashboard-shell .leftNav>ul.utility-nav>li:hover>a,
.dashboard-shell .leftNav>ul.utility-nav>li.on>a {background:linear-gradient(90deg,rgba(124,58,237,.18),rgba(20,184,166,.05))}
.dashboard-shell .leftNav>ul>li>a::before,
.dashboard-shell .leftNav>ul.utility-nav>li>a::before {background:linear-gradient(#8b5cf6,#5eead4)}
.dashboard-shell .leftNav .dropdown-menu {border-color:rgba(167,139,250,.25);background:rgba(15,14,29,.98)}
.dashboard-shell .leftNav .dropdown-menu a:hover {color:#d8ccff;background:rgba(124,58,237,.14)}
.dashboard-shell .footerInfo.w1260 {width:min(1260px,calc(100% - 32px));box-sizing:border-box}
.dashboard-shell .footerInfo img {max-width:100%;height:auto}

/* MEGA orbit sub-navigation */
.dashboard-shell .leftHeader {
  border-right-color:rgba(107,228,255,.15);
  background:
    radial-gradient(circle at 50% 8%,rgba(107,228,255,.16),transparent 24%),
    radial-gradient(circle at 35% 72%,rgba(200,255,99,.05),transparent 30%),
    linear-gradient(180deg,#0e171c 0%,#080d10 74%)
}
.dashboard-shell .leftHeader .logowrap a {
  width:58px;
  height:58px;
  border:0;
  background:transparent;
  box-shadow:0 12px 30px rgba(0,0,0,.32)
}
.dashboard-shell .leftHeader .logowrap a::after {display:none}
.dashboard-shell .leftHeader .logowrap img {display:block!important;width:58px;height:58px;object-fit:contain}
.dashboard-shell .leftNav>ul.utility-nav.money-nav {border-top-color:rgba(107,228,255,.14)}
.dashboard-shell .leftNav>ul>li>a,
.dashboard-shell .leftNav>ul.utility-nav>li>a {color:#8f9da2}
.dashboard-shell .leftNav>ul>li:hover>a,
.dashboard-shell .leftNav>ul>li.on>a,
.dashboard-shell .leftNav>ul>li>a.on,
.dashboard-shell .leftNav>ul.utility-nav>li:hover>a,
.dashboard-shell .leftNav>ul.utility-nav>li.on>a {
  color:#f4f8f8;
  background:linear-gradient(90deg,rgba(107,228,255,.14),rgba(200,255,99,.035))
}
.dashboard-shell .leftNav>ul>li>a::before,
.dashboard-shell .leftNav>ul.utility-nav>li>a::before {background:linear-gradient(#6be4ff,#c8ff63)}
.dashboard-shell .leftNav .dropdown-menu {border-color:rgba(107,228,255,.22);background:rgba(8,15,19,.98)}
.dashboard-shell .leftNav .dropdown-menu a:hover {color:#c8ff63;background:rgba(107,228,255,.1)}

/* cleaner notice surface */
.subpage-shell .boardwrap {
  padding:0!important;
  border:0!important;
  border-radius:0!important;
  background:transparent!important;
  box-shadow:none!important
}
.subpage-shell .boardsearch {
  align-self:flex-end;
  margin:0 0 4px!important
}
.subpage-shell .board {
  border-color:rgba(107,228,255,.13);
  border-radius:12px;
  background:#10161a
}
.subpage-shell .board>.boardw.first:first-child {border-top:0;background:#0b1013;color:#7f9096}
.subpage-shell .boardw {border-bottom-color:rgba(255,255,255,.065);background:#10161a}
.subpage-shell .boardw:hover {background:rgba(107,228,255,.045)}
.subpage-shell .subBanner img {filter:hue-rotate(120deg) saturate(1.25)}

/* unified orbit tabs and action buttons */
.subpage-shell .navSide {margin-bottom:22px}
.subpage-shell .boardnav {
  height:auto;
  min-height:58px;
  padding:6px;
  gap:6px;
  border:1px solid rgba(107,228,255,.13);
  border-radius:13px;
  background:rgba(10,17,21,.88);
  align-items:stretch;
  box-sizing:border-box
}
.subpage-shell .boardnav>li {display:flex;flex:1 1 0;width:auto;min-width:0}
.subpage-shell .boardnav>li>span {
  width:100%;
  min-width:0;
  height:44px;
  padding:0 16px;
  border:1px solid transparent!important;
  border-radius:8px;
  background:transparent!important;
  color:#819096!important;
  font-size:11px;
  font-weight:700;
  transition:color .18s,border-color .18s,background .18s,transform .18s
}
.subpage-shell .boardnav>li:hover>span {
  border-color:rgba(107,228,255,.16)!important;
  background:rgba(107,228,255,.055)!important;
  color:#d9e7e9!important
}
.subpage-shell .boardnav>li.on>span,
.subpage-shell .boardnav>li>span.on {
  border-color:rgba(107,228,255,.38)!important;
  background:linear-gradient(135deg,rgba(107,228,255,.16),rgba(200,255,99,.07))!important;
  color:#c8ff63!important;
  box-shadow:inset 0 0 18px rgba(107,228,255,.035),0 8px 20px rgba(0,0,0,.16)
}
.subpage-shell .boardnav>li.on>span::after,
.subpage-shell .boardnav>li>span.on::after {display:none!important}
.subpage-shell .applibtns {display:flex;justify-content:flex-end;margin:20px 0 30px}
.subpage-shell .applibtns a,
.subpage-shell .applibtns button {
  display:inline-flex;
  align-items:center;
  justify-content:center;
  min-width:160px;
  height:44px;
  padding:0 24px;
  border:1px solid #c8ff63!important;
  border-radius:9px!important;
  background:#c8ff63!important;
  color:#0a1114!important;
  font-size:11px;
  font-weight:900;
  text-shadow:none!important;
  box-shadow:0 10px 26px rgba(200,255,99,.11)!important;
  cursor:pointer;
  transition:transform .18s,background .18s,box-shadow .18s
}
.subpage-shell .applibtns a:hover,
.subpage-shell .applibtns button:hover {
  transform:translateY(-2px);
  background:#d8ff8c!important;
  box-shadow:0 14px 30px rgba(200,255,99,.18)!important
}
.subpage-shell .applibtn {
  border-color:rgba(107,228,255,.28)!important;
  background:rgba(107,228,255,.08)!important;
  color:#9cecff!important
}
.subpage-shell .boardbtn .grbbtn,
.subpage-shell .boardbtn .grsbtn {
  border-color:rgba(107,228,255,.28)!important;
  background:rgba(107,228,255,.08)!important;
  color:#a8edf9!important
}
.subpage-shell .boardbtn .grbbtn:hover,
.subpage-shell .boardbtn .grsbtn:hover {border-color:#6be4ff!important;background:rgba(107,228,255,.14)!important;color:#f4f8f8!important}
@media(max-width:640px){
  .subpage-shell .boardnav {overflow-x:auto;justify-content:flex-start}
  .subpage-shell .boardnav>li {flex:0 0 auto;min-width:135px}
  .subpage-shell .applibtns a,.subpage-shell .applibtns button {width:100%}
}

/* Full-width service shell */
body.mega13-nova-body {background:#0c0e10}
.dashboard-root,.dashboard-root .dashboard-shell,.dashboard-root .dashboard-shell .content0 {background:#0c0e10!important}
.dashboard-root .dashboard-shell .leftHeader {display:none!important}
.dashboard-root .dashboard-shell .content0 {width:100%!important;margin:0!important}
.dashboard-root header#mainheader.main-editorial-header {right:0!important;left:0!important;width:auto!important}

/* MEGA application shell tokens */
body.mega13-nova-body {background:#f3f7fc;color:#112f55}
.dashboard-root,.dashboard-shell,.dashboard-shell .content0 {background:#f3f7fc!important}
.dashboard-shell {
  --mega-primary:#075ee8;
  --mega-primary-bright:#3183f4;
  --mega-secondary:#d9a63c;
  --mega-text:#102e54;
  --mega-muted:#72869f;
}
.dashboard-shell .leftHeader {
  border-right:1px solid #d5e3f2;
  background:radial-gradient(circle at 50% 8%,rgba(40,126,240,.12),transparent 23%),linear-gradient(180deg,#f7fbff,#eaf3fd 75%);
  box-shadow:10px 0 30px rgba(39,78,126,.08)
}
.dashboard-shell .leftHeader .logowrap a {border:1px solid #b9d3f3;background:#fff;box-shadow:0 10px 24px rgba(24,85,160,.12)}
.dashboard-shell .leftHeader .logowrap img {display:block!important;width:54px;height:54px;object-fit:contain}
.dashboard-shell .leftNav>ul.utility-nav.money-nav {border-top-color:#d5e2f0}
.dashboard-shell .leftNav>ul>li>a,
.dashboard-shell .leftNav>ul.utility-nav>li>a {color:#58708d}
.dashboard-shell .leftNav>ul>li>a em,
.dashboard-shell .leftNav>ul.utility-nav>li>a em {filter:invert(37%) sepia(20%) saturate(946%) hue-rotate(171deg);opacity:.72}
.dashboard-shell .leftNav>ul>li:hover>a,
.dashboard-shell .leftNav>ul>li.on>a,
.dashboard-shell .leftNav>ul>li>a.on,
.dashboard-shell .leftNav>ul.utility-nav>li:hover>a,
.dashboard-shell .leftNav>ul.utility-nav>li.on>a {color:#075ee8;background:#e1efff}
.dashboard-shell .leftNav>ul>li>a::before,
.dashboard-shell .leftNav>ul.utility-nav>li>a::before {background:#075ee8}
.dashboard-shell .leftNav .dropdown-menu {border-color:#cbdced;background:rgba(255,255,255,.98);box-shadow:15px 20px 44px rgba(24,69,122,.16)}
.dashboard-shell .leftNav .dropdown-menu a {color:#526b87}
.dashboard-shell .leftNav .dropdown-menu a:hover {color:#075ee8;background:#edf5ff}
.subpage-shell .content0.sub {background:linear-gradient(180deg,#eef5fd,#f8fbff 300px);color:#17385f}
.subpage-shell .subBanner {color:#102f56}
.subpage-shell .subBanner img {filter:invert(32%) sepia(91%) saturate(2253%) hue-rotate(209deg)}
.subpage-shell .boardnav {border-color:#d9e5f2;background:#fff;box-shadow:0 8px 22px rgba(29,72,125,.06)}
.subpage-shell .boardnav>li>span {color:#72869f!important}
.subpage-shell .boardnav>li:hover>span {border-color:#bdd4f0!important;background:#eff6ff!important;color:#075ee8!important}
.subpage-shell .boardnav>li.on>span,.subpage-shell .boardnav>li>span.on {border-color:#075ee8!important;background:#075ee8!important;color:#fff!important;box-shadow:0 8px 18px rgba(7,94,232,.18)}
.subpage-shell .moneyread,.subpage-shell .mybetwrap,.subpage-shell .board,.subpage-shell .moneyinfoappli,
.subpage-shell .datesearch,.subpage-shell .rollName,.subpage-shell .pointlist>li,.subpage-shell .joinubottom {border-color:#d8e4f1;background:#fff;color:#526a85;box-shadow:0 8px 24px rgba(29,72,125,.055)}
.subpage-shell .board>.boardw.first:first-child {background:#edf5ff;color:#657d98}
.subpage-shell .boardw,.subpage-shell .wblbg.boardw,.subpage-shell .wywbg.boardw {border-bottom-color:#e4ecf5;background:#fff;color:#4c6581}
.subpage-shell .boardw:hover {background:#f3f8ff}
.subpage-shell .boardw .bkc,.subpage-shell .boardw .ywc {color:#16385f}
.subpage-shell .moneyread h3,.subpage-shell .applih,.subpage-shell .applistep strong,.subpage-shell .rollName span,.subpage-shell .pointlist .rolling {color:#075ee8}
.subpage-shell .appliinput li:nth-child(2),.subpage-shell .datesearch>select,.subpage-shell .searchselect,.subpage-shell .searchinput,
.subpage-shell .boardwrt input,.subpage-shell .boardwrt select,.subpage-shell .boardwrt textarea,.subpage-shell .joinu input,
.subpage-shell .datewrap,.subpage-shell .joinu li+li,.subpage-shell .joinu li.myfix_id {border-color:#d5e2f0;background:#f7faff;color:#17385f}
.subpage-shell .applibtns a,.subpage-shell .applibtns button {border-color:#075ee8!important;background:#075ee8!important;color:#fff!important;box-shadow:0 10px 24px rgba(7,94,232,.17)!important}
.subpage-shell .applibtn,.subpage-shell .boardbtn .grbbtn,.subpage-shell .boardbtn .grsbtn {border-color:#9fc1ea!important;background:#edf5ff!important;color:#075ee8!important}

/* Royal casino surface tokens */
body.mega13-nova-body,.dashboard-root,.dashboard-shell,.dashboard-shell .content0 {background:#031024!important;color:#edf3fa}
.dashboard-shell {--mega-primary:#e2b553;--mega-primary-bright:#f2d17e;--mega-secondary:#1268eb;--mega-text:#f5f8fc;--mega-muted:#7b91ad}
.dashboard-shell .leftHeader {border-right-color:rgba(226,181,83,.22);background:radial-gradient(circle at 50% 8%,rgba(226,181,83,.15),transparent 24%),linear-gradient(180deg,#081c38,#031024 76%);box-shadow:10px 0 32px rgba(0,0,0,.25)}
.dashboard-shell .leftHeader .logowrap a {border-color:rgba(226,181,83,.38);background:#0d294e;box-shadow:0 10px 25px rgba(0,0,0,.25)}
.dashboard-shell .leftNav>ul.utility-nav.money-nav {border-top-color:rgba(226,181,83,.16)}
.dashboard-shell .leftNav>ul>li>a,.dashboard-shell .leftNav>ul.utility-nav>li>a {color:#8197b1}
.dashboard-shell .leftNav>ul>li>a em,.dashboard-shell .leftNav>ul.utility-nav>li>a em {filter:grayscale(1) brightness(1.9) sepia(.32);opacity:.72}
.dashboard-shell .leftNav>ul>li:hover>a,.dashboard-shell .leftNav>ul>li.on>a,.dashboard-shell .leftNav>ul>li>a.on,.dashboard-shell .leftNav>ul.utility-nav>li:hover>a,.dashboard-shell .leftNav>ul.utility-nav>li.on>a {color:#f0c86c;background:linear-gradient(90deg,rgba(31,98,195,.22),rgba(226,181,83,.06))}
.dashboard-shell .leftNav>ul>li>a::before,.dashboard-shell .leftNav>ul.utility-nav>li>a::before {background:linear-gradient(#f1cf7b,#c68b26)}
.dashboard-shell .leftNav .dropdown-menu {border-color:rgba(226,181,83,.24);background:rgba(5,21,45,.98);box-shadow:15px 20px 44px rgba(0,0,0,.35)}.dashboard-shell .leftNav .dropdown-menu a {color:#92a7bf}.dashboard-shell .leftNav .dropdown-menu a:hover {color:#f0c86c;background:rgba(30,97,193,.18)}
.subpage-shell .content0.sub {background:radial-gradient(circle at 88% 0,rgba(30,97,193,.18),transparent 30%),linear-gradient(180deg,#061832,#031024);color:#d8e3ef}
.subpage-shell .subBanner {color:#fff}.subpage-shell .subBanner img {filter:invert(78%) sepia(64%) saturate(465%) hue-rotate(355deg)}
.subpage-shell .boardnav {border-color:rgba(226,181,83,.2);background:#091e3b;box-shadow:0 9px 24px rgba(0,0,0,.2)}.subpage-shell .boardnav>li>span {color:#7890ad!important}.subpage-shell .boardnav>li:hover>span {border-color:rgba(226,181,83,.3)!important;background:#0d294f!important;color:#efc76b!important}.subpage-shell .boardnav>li.on>span,.subpage-shell .boardnav>li>span.on {border-color:#e2b553!important;background:linear-gradient(135deg,#f0ca6e,#c78d27)!important;color:#071a37!important;box-shadow:0 8px 20px rgba(205,151,44,.18)}
.subpage-shell .moneyread,.subpage-shell .mybetwrap,.subpage-shell .board,.subpage-shell .moneyinfoappli,.subpage-shell .datesearch,.subpage-shell .rollName,.subpage-shell .pointlist>li,.subpage-shell .joinubottom {border-color:rgba(226,181,83,.17);background:#091e3b;color:#a9bacd;box-shadow:0 9px 25px rgba(0,0,0,.2)}
.subpage-shell .board>.boardw.first:first-child {background:#0d294f;color:#8299b4}.subpage-shell .boardw,.subpage-shell .wblbg.boardw,.subpage-shell .wywbg.boardw {border-bottom-color:rgba(226,181,83,.11);background:#091e3b;color:#aec0d3}.subpage-shell .boardw:hover {background:#0d294f}.subpage-shell .boardw .bkc,.subpage-shell .boardw .ywc {color:#f1f5fa}
.subpage-shell .moneyread h3,.subpage-shell .applih,.subpage-shell .applistep strong,.subpage-shell .rollName span,.subpage-shell .pointlist .rolling {color:#efc76b}
.subpage-shell .appliinput li:nth-child(2),.subpage-shell .datesearch>select,.subpage-shell .searchselect,.subpage-shell .searchinput,.subpage-shell .boardwrt input,.subpage-shell .boardwrt select,.subpage-shell .boardwrt textarea,.subpage-shell .joinu input,.subpage-shell .datewrap,.subpage-shell .joinu li+li,.subpage-shell .joinu li.myfix_id {border-color:rgba(226,181,83,.15);background:#06152d;color:#edf3fa}
.subpage-shell .applibtns a,.subpage-shell .applibtns button {border-color:#e2b553!important;background:linear-gradient(135deg,#f0ca6e,#c78d27)!important;color:#071a37!important;box-shadow:0 10px 24px rgba(205,151,44,.16)!important}.subpage-shell .applibtn,.subpage-shell .boardbtn .grbbtn,.subpage-shell .boardbtn .grsbtn {border-color:rgba(226,181,83,.3)!important;background:rgba(226,181,83,.08)!important;color:#efc76b!important}

/* Horizontal casino quick bar */
.subpage-shell {display:block!important;padding:0!important}
.subpage-shell .content0 {width:100%!important;margin:0!important}
.subpage-shell .content0.sub {padding-top:176px!important}
.subpage-shell .leftHeader {
  position:fixed!important;
  top:70px!important;
  right:0!important;
  left:0!important;
  z-index:35!important;
  width:100%!important;
  min-width:0!important;
  min-height:0!important;
  height:78px!important;
  max-height:78px!important;
  padding:0!important;
  overflow:visible!important;
  border:0!important;
  border-bottom:1px solid rgba(226,181,83,.24)!important;
  background:linear-gradient(90deg,rgba(5,19,42,.98),rgba(10,39,75,.98) 50%,rgba(5,19,42,.98))!important;
  box-shadow:0 12px 30px rgba(0,0,0,.24)!important
}
.subpage-shell .leftHeader>ul {
  width:min(1440px,100%)!important;
  height:78px!important;
  margin:0 auto!important;
  padding:0 24px!important;
  display:flex!important;
  align-items:center!important;
  gap:18px!important;
  box-sizing:border-box!important
}
.subpage-shell .leftHeader>ul>li {width:auto!important;height:100%!important;display:flex!important;align-items:center!important}
.subpage-shell .leftHeader .logowrap {width:66px!important;height:58px!important;margin:0!important;flex:0 0 66px!important}
.subpage-shell .leftHeader .logowrap a {width:52px!important;height:52px!important;margin:0!important;border:1px solid rgba(226,181,83,.38)!important;border-radius:15px!important;background:#0d2b52!important;box-shadow:inset 0 0 20px rgba(43,119,213,.16),0 7px 19px rgba(0,0,0,.24)!important}
.subpage-shell .leftHeader .logowrap img {display:block!important;width:48px!important;height:48px!important;object-fit:contain!important}
.subpage-shell .leftHeader>ul>li:nth-child(2) {min-width:0!important;flex:1!important}
.subpage-shell .leftNav {width:100%!important;height:78px!important;padding:0!important;display:flex!important;flex-flow:row nowrap!important;align-items:center!important;gap:3px!important;overflow:visible!important}
.subpage-shell .leftNav>ul,
.subpage-shell .leftNav>ul.utility-nav,
.subpage-shell .leftNav>ul.utility-nav.money-nav {position:relative!important;width:auto!important;height:58px!important;margin:0!important;padding:0!important;display:flex!important;flex:0 0 auto!important;align-items:center!important;gap:3px!important;border:0!important;order:initial!important}
.subpage-shell .leftNav>ul.utility-nav.money-nav {margin-left:auto!important;padding-left:12px!important;border-left:1px solid rgba(226,181,83,.18)!important}
.subpage-shell .leftNav>ul>li,
.subpage-shell .leftNav>ul.utility-nav>li {position:relative!important;width:auto!important;min-width:0!important;min-height:0!important;height:50px!important;margin:0!important;padding:0!important}
.subpage-shell .leftNav>ul>li>a,
.subpage-shell .leftNav>ul.utility-nav>li>a {width:auto!important;min-width:74px!important;height:50px!important;margin:0!important;padding:0 11px!important;display:flex!important;align-items:center!important;justify-content:center!important;gap:7px!important;border:1px solid transparent!important;border-radius:10px!important;color:#8fa4bd!important;font-size:9px!important;white-space:nowrap!important;box-sizing:border-box!important}
.subpage-shell .leftNav>ul>li>a em,
.subpage-shell .leftNav>ul.utility-nav>li>a em {width:21px!important;height:28px!important;flex:0 0 21px!important;background-size:17px!important;opacity:.72!important}
.subpage-shell .leftNav>ul>li>a::before,
.subpage-shell .leftNav>ul.utility-nav>li>a::before {top:auto!important;right:14px!important;bottom:-5px!important;left:14px!important;width:auto!important;height:2px!important;background:linear-gradient(90deg,transparent,#edc66a,transparent)!important}
.subpage-shell .leftNav>ul>li:hover>a,
.subpage-shell .leftNav>ul>li.on>a,
.subpage-shell .leftNav>ul>li>a.on,
.subpage-shell .leftNav>ul.utility-nav>li:hover>a,
.subpage-shell .leftNav>ul.utility-nav>li.on>a {border-color:rgba(226,181,83,.2)!important;background:linear-gradient(180deg,rgba(38,105,199,.2),rgba(226,181,83,.055))!important;color:#f2ca70!important}
.subpage-shell .leftNav .dropdown-menu {position:absolute!important;top:58px!important;right:auto!important;left:0!important;width:245px!important;max-height:390px!important;border:1px solid rgba(226,181,83,.25)!important;border-radius:12px!important;background:rgba(5,21,45,.99)!important;box-shadow:0 20px 45px rgba(0,0,0,.38)!important}
.subpage-shell .leftNav .dropdown-menu a {min-width:0!important;height:38px!important;padding:0 12px!important;justify-content:flex-start!important}
@media(max-width:1280px){
  .subpage-shell .leftHeader>ul {padding:0 14px!important;gap:7px!important}
  .subpage-shell .leftHeader .logowrap {width:55px!important;flex-basis:55px!important}
  .subpage-shell .leftNav>ul>li>a,.subpage-shell .leftNav>ul.utility-nav>li>a {min-width:62px!important;padding:0 7px!important;font-size:8px!important}
  .subpage-shell .leftNav>ul.utility-nav.money-nav {padding-left:5px!important}
}
@media(max-width:1000px){
  .subpage-shell .content0.sub {padding-top:176px!important}
  .subpage-shell .leftHeader {display:block!important}
  .subpage-shell .leftHeader>ul {padding:0 10px!important;gap:4px!important}
  .subpage-shell .leftHeader .logowrap {width:50px!important;flex-basis:50px!important}
  .subpage-shell .leftHeader .logowrap a {width:46px!important;height:46px!important}
  .subpage-shell .leftHeader .logowrap img {width:43px!important;height:43px!important}
  .subpage-shell .leftNav {gap:1px!important}
  .subpage-shell .leftNav>ul,.subpage-shell .leftNav>ul.utility-nav,.subpage-shell .leftNav>ul.utility-nav.money-nav {gap:1px!important}
  .subpage-shell .leftNav>ul>li>a,.subpage-shell .leftNav>ul.utility-nav>li>a {min-width:58px!important;padding:0 5px!important;gap:4px!important;font-size:8px!important}
  .subpage-shell .leftNav>ul>li>a em,.subpage-shell .leftNav>ul.utility-nav>li>a em {width:18px!important;flex-basis:18px!important;background-size:15px!important}
}
</style>
